import { Smartphone } from "lucide-react";

const DEFAULT_ITEMS = [
  "Celulares e Acessórios",
  "Assistência Técnica Especializada",
  "Atendimento Humano via WhatsApp",
  "Entrega Rápida na Região",
  "Envio para Todo o Brasil",
];

function MarqueeRow({ items, hidden }) {
  return (
    <div
      className="flex items-center gap-12 font-display text-sm font-medium tracking-wide uppercase text-[#5A534C] whitespace-nowrap pr-12"
      aria-hidden={hidden}
    >
      {items.map((label, i) => (
        <span key={`${label}-${i}`} className="flex items-center gap-12">
          <span className="flex items-center gap-2">
            <Smartphone className="w-4 h-4 text-[var(--brand)]" />
            {label}
          </span>
          <span>•</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee({ items }) {
  const list = items?.length ? items : DEFAULT_ITEMS;
  return (
    <div className="border-y border-[#E8E2D9] py-4 bg-[#F2EDE4] overflow-hidden">
      <div className="mq-track">
        <MarqueeRow items={list} />
        <MarqueeRow items={list} hidden />
      </div>
    </div>
  );
}
